// Must stay first: relays fetch/WebSocket before any other module can use them.
import './devBackend/install';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import DevBackendBadge from './devBackend/DevBackendBadge';

// Stale-chunk recovery. After a deploy the hashed chunk filenames change and the
// old ones are removed, so a tab still running the previous build fails to load a
// lazy route chunk → ChunkLoadError. Reload to pull the new manifest.
//
// Lazy chunks load on *navigation*, long after the initial `load` event, so we
// can't clear a "reloaded" flag on load — a genuinely-missing chunk (bad deploy,
// CDN gap) would then reload forever. Instead we throttle: reload at most once
// per RELOAD_WINDOW. A stale-chunk-after-deploy resolves in one reload; a truly
// broken chunk reloads at most once per window instead of tight-looping.
// import() failures surface as promise rejections, so catch unhandledrejection too.
const CHUNK_RE = /ChunkLoadError|Loading (?:CSS )?chunk [\w-]+ failed|Failed to fetch dynamically imported module|error loading dynamically imported module/i;
const RELOAD_WINDOW = 10_000;
function recoverFromStaleChunk(reason: unknown): void {
  const msg = String((reason as { message?: string } | null)?.message ?? reason ?? '');
  if (!CHUNK_RE.test(msg)) return;
  const last = Number(sessionStorage.getItem('chunk-reload-at') || 0);
  if (Date.now() - last < RELOAD_WINDOW) return; // just tried — don't loop
  sessionStorage.setItem('chunk-reload-at', String(Date.now()));
  window.location.reload();
}
window.addEventListener('error', (e) => recoverFromStaleChunk(e.error || e.message));
window.addEventListener('unhandledrejection', (e) => recoverFromStaleChunk(e.reason));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
    <DevBackendBadge />
  </React.StrictMode>
);

